import * as storage from './storage'

// Configura o header se o token existir no localStorage
const token = storage.getLocalToken()
if (token) {
    storage.setHeaderToken(token)
}

// Recupera o usuário do localStorage
const localUser = storage.getLocalUser()
const user = localUser ? JSON.parse(localUser) : {
    menu: [],
    domain: {}
}

export default {
    user: user,
    token: token || '',
    domain: storage.getLocalDomain() ? JSON.parse(storage.getLocalDomain()) : {}
}
